<template>
	<section class="my-modal-custom">
		<div class="align-center">
			<div class="container-modal animate__animated animate__fadeInDown">
				<div class="box-modal">
					<div class="modal-title">
						<h1>Selecione um Motivo</h1>
						<feather class="feather-icon" type="x" size="14" @click="$emit('close')" />
					</div>
					<div class="box-container">
						<div
							v-for="motivo in motstatus"
							:key="motivo.id"
							class="itemselect"
							@click="$emit('select', motivo.id)"
						>
							<h1>
								{{ motivo.descricao }}
							</h1>
						</div>
					</div>
				</div>
				<div class="cancelbutton" @click="$emit('close')">Cancelar</div>
			</div>
			<div />
		</div>
	</section>
</template>

<script>
import * as ecAxios from '../../../util/ecAxios';

export default {
	data() {
		return {
			motstatus: [],
		};
	},
	created() {
		this.getAllMotStatus();
	},
	methods: {
		async getAllMotStatus() {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC + api.env.EC_MOTIVO_STATUS}`;
				const request = await ecAxios.connection().get(`${url}`);
				const { data } = request;
				if (data.error !== 1) {
					this.motstatus = data.motstatus;
				} else {
					// eslint-disable-next-line no-throw-literal
					throw { message: data.message };
				}
			} catch (e) {
				// eslint-disable-next-line no-console
				console.error(e);
				// eslint-disable-next-line no-alert
				alert(e.message || 'Ops! Ocorreu um erro ao buscar dados');
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.align-center {
	width: 100%;
	height: 100vh;
	display: flex;
	justify-content: center;
	align-items: center;
}
.my-modal-custom {
	position: fixed;
	z-index: 9999;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.24);
	display: table;
	transition: all 0.5s ease;
	overflow-y: scroll;
	align-items: flex-end;
}
.feather-icon {
	background-color: #ff3b30;
	padding: 2px;
	border-radius: 50%;
	color: #fff;
	cursor: pointer;
	transition: 300ms ease;
}
.feather-icon:hover {
	background-color: #cc342c;
}
.itemselect {
	width: 100%;
	align-items: center;
	justify-content: center;
	text-align: center;
	border-top: 1px solid #dfdfe1c5;
	cursor: pointer;
}
.itemselect h1 {
	font-size: 12px;
	padding: 15px;
	width: 100%;
	height: 100%;
	transition: 500ms ease;
}
.itemselect h1:hover {
	transform: scale(1.1);
}
.box-container {
	margin-top: 10px;
	display: flex;
	flex-direction: column;
	align-items: center;
	height: 100%;
	justify-content: center;
}
.modal-title {
	width: 100%;
	font-size: 14px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 20px;
	border-bottom: 1px solid #dfdfe1c5;
}
.container-modal {
	position: absolute;
	width: 300px;
	border-radius: 5px;
}
.box-modal {
	background-color: #fff;
	width: 100%;
	display: flex;
	flex-direction: column;
	height: 90%;
	border-radius: 10px;
}
.cancelbutton {
	background-color: #ff3b30;
	padding: 10px;
	margin-top: 10px;
	border-radius: 10px;
	text-align: center;
	color: #fff;
	cursor: pointer;
	transition: 500ms ease;
	font-size: 14px;
}
.cancelbutton:hover {
	background-color: #cc342c;
}
</style>

